import { render, staticRenderFns } from "./ChatContextMenu.vue?vue&type=template&id=137b4bcd"
import script from "./ChatContextMenu.vue?vue&type=script&lang=js"
export * from "./ChatContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatContextMenu.vue?vue&type=style&index=0&id=137b4bcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports